import { createContext } from 'react';

export const CheckContext = createContext();

export default CheckContext;
